var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93774 3.79356L8.87737 7.30975L10.8495 6.12512C10.8495 6.12512 8.46787 2.87612 7.83562 3.10506C7.20522 3.34046 6.57256 3.57035 5.93774 3.79356ZM10.9237 6.12512C10.9237 6.12512 11.3709 5.32244 11.5942 4.252C11.5942 4.252 13.8268 5.16887 12.9707 7.46275L10.9237 6.12512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9712 7.46265L13.1569 9.87015L14.013 9.75596C14.013 9.75596 14.2363 9.67946 14.1986 9.25928C14.1615 8.80028 14.0872 7.84459 14.0872 7.84459C14.0872 7.84459 14.1244 7.61565 13.6035 7.53915C12.9707 7.4244 12.9712 7.46265 12.9712 7.46265ZM13.1569 9.87015L11.4452 11.2848L12.2271 12.852C12.2271 12.852 12.4127 13.4634 12.9712 12.7755C13.4921 12.0875 13.7154 11.9728 13.6777 11.5526C13.6406 11.1318 13.5292 10.1373 13.1569 9.87015ZM11.4075 11.2848L9.06356 10.2144L7.01662 14.4573C7.01662 14.4573 6.86812 14.7628 7.389 14.801C7.90987 14.8775 8.766 15.0688 9.21262 14.6098C9.65925 14.1896 11.4075 11.2848 11.4075 11.2848ZM9.06356 10.1762L8.84025 7.3479L3.77943 7.69215C3.77943 7.69215 3.48131 7.7304 3.519 8.30359C3.55612 9.06803 3.63037 9.90896 3.63037 9.90896C3.63037 9.90896 3.59325 10.2527 4.26318 10.2915C4.93256 10.3292 8.98931 10.3292 9.06356 10.1762Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQnt);
export default __webpack_public_path__ + "static/media/qnt.1552c1f4ac6c5b3ae2711382058b747a.svg";
export { ForwardRef as ReactComponent };